import api from "../../utils/axios-util";
import Middleware from "../../utils/api-middleware"
// export const AsterCampaigns = (temp_campaign) => {
//     return (dispatch, getState) => {
//         return new Promise(async (resolve, reject) => {
//             var apinfo = JSON.parse(localStorage.getItem("apinfo")) || "{}";
//             await api
//                 .get(`/campaign/fetch?tid=${apinfo.tenant_code}&name=${temp_campaign}`)
//                 .then((response) => {
//                     resolve(response);
                    
//                 })
//                 .catch((err) => {
//                     reject(err);
//                 });
//         });
//     };
// };
// edit
export const AsterAgentTable = (payload) =>{
  return (dispatch,getState) =>{
    return new Promise(async(resolve,reject)=>{
      await api.post(`/setdianamic/fields`,payload)
      .then((response)=>{
         let res= Middleware("dynamic table header","fetch",response)
          resolve(res);
                           
      }).catch((err)=>{ 
         let res= Middleware("dynamic table header","fetch",err.response.data,"catch")
          reject(res);
      })
    })
  }
}

export const AsterAgentTableField = (payload) =>{
  return (dispatch,getState) =>{
    return new Promise(async(resolve,reject)=>{
      await api.get(`/getdianamic/fields?agent=${payload.user}&campaign=${payload.campaign}&template=${payload.template}&module=${payload.module}&all=${payload.fields}`)
      .then((response)=>{
        let res= Middleware("dynamic table header","fetch",response)
          
        if(res.statusCode === 200){
          const leadDetailsPriority = 
          ['lead_id', 'first_name', 'last_name', 'phone_number'
          , 'alt_number', 'address', 'email', 'disposition'];
          const contactDetailPriority = [
            'id','name','phone_number','alternative_number'
          ]
          const meetingDetailPriority = [
            'meeting_id','meeting_name','meeting_sub_title','phone_number','schedule_date','Status','module'
          ]
          const ticketDetailPriority = [
            'ticket_id','account_name','phone_number','status','priority','subject'
          ]
          const voicemailDetailPriority = [
            'phone_number','Campaign','calldate','Queue'
          ]
          const allPriorityData = payload.module === 'lead' ?
          leadDetailsPriority : payload.module === 'contact' ?
          contactDetailPriority : payload.module ==='meeting' ? meetingDetailPriority :
          payload.module === 'ticket' ? ticketDetailPriority : 
          payload.module === 'voicemail' ? voicemailDetailPriority : []
          res.data.sort((a, b) => {
            const isADetail = allPriorityData.includes(a.model);
            const isBDetail = allPriorityData.includes(b.model);
            if (isADetail && !isBDetail) {
              return -1; 
            }
            if (!isADetail && isBDetail) {
              return 1; 
            }
            if (isADetail && isBDetail) {
              return allPriorityData.indexOf(a.model) - allPriorityData.indexOf(b.model);
            }
            return 0;
          }).map((item) => {
            if(item.name !== payload.template){
              item.agent_table_show = item.agent_table_show.filter(subItem => subItem.name === payload.template);
              item.agent_table_show = item.agent_table_show[0].showOn
            }
          })
    
      
        }
        resolve(res)
      }).catch((err)=>{
        let res= Middleware("dynamic table header","fetch",err.response.data,"catch")
          reject(res);
      })
    })
  }
}

export const AsterAgentTableUpdate = (payload,agent) =>{
  return (dispatch,getState) => {
    return new Promise(async (resolve,reject) => {
      await api.put(`/dianamic/fields/${agent}`,payload)
      .then((response)=>{
        let res= Middleware("dynamic table header","update",response)
        resolve(res);
      }).catch((err)=>{
        let res= Middleware("dynamic table header","update",err.response.data,"catch")
          reject(res);
      })
    })
  }
}
// edit
export const AsterGetCampaignsData = (payload) => {
    return (dispatch, getState) => {
      return new Promise(async (resolve, reject) => {
        await api.get(`/campaign?campaign_name=${payload}`).then(response => {
          let res= Middleware("campaign","fetch",response)
        resolve(res);
          
        }).catch((err) => {
          let res= Middleware("campaign","fetch",err.response.data,"catch")
          reject(res);
        })
      })
    };    
  
  };

  export const PauseCodeDuration = (payload) => {
    return (dispatch, getState) => {
      return new Promise(async (resolve, reject) => {
        await api.get(`/pausecode?pause_code=${payload}`).then(response => {
          let res= Middleware("pause code","fetch",response)
        resolve(res);
          
        }).catch((err) => {
          let res= Middleware("pause code","fetch",err.response.data,"catch")
          reject(res);
        })
      })
    };
  }

  export const liveagentdata = (payload) => {
    return (dispatch, getState) => {
      return new Promise(async (resolve, reject) => {
        await api.get(`/liveagent/datafetch?user=${payload}`).then(response => {
          let res= Middleware("live agent","fetch",response)
        resolve(res);
          
        }).catch((err) => {
          let res= Middleware("live agent","fetch",err.response.data,"catch")
          reject(res);
        })
      })
    };
  }